const enum IntegrationState {
  /// <summary>
  /// A webhook is being processed.
  /// </summary>
  Processing = 0,

  /// <summary>
  /// A webhook has completed processing.
  /// </summary>
  Completed = 1,

  /// <summary>
  /// A user has overridden the processing webhook.
  /// </summary>
  Override = 2,

  /// <summary>
  /// The step has been canceled.
  /// </summary>
  Canceled = 3
}

export default IntegrationState;
